export default {
  nav: {
    about: 'Про платформу',
    forWhom: 'Для кого',
    opportunities: 'Можливості',
    faq: 'FAQ'
  },
  hero: {
    badge: 'Платформа людського інтелекту',
    title: 'Людський інтелект для епохи ШІ',
    subtitle: 'Заробляйте віддалено, допомагаючи навчати передові AI-моделі та створюючи якісні датасети для AGI',
    englishRequired: '🇬🇧 Необхідне вільне володіння англійською мовою'
  },
  cta: {
    start: 'Почати',
    getStarted: 'Приєднатися зараз',
    learnMore: 'Дізнатися більше',
    startNow: 'Почати зараз'
  },
  about: {
    badge: 'Про micro1',
    title: 'Платформа нового покоління для роботи з даними',
    desc1: 'micro1 — це глобальна платформа, яка об\'єднує експертів з усього світу для створення високоякісних даних, необхідних для навчання передових AI-моделей і систем штучного загального інтелекту (AGI).',
    desc2: 'Ми співпрацюємо з провідними AI-лабораторіями та технологічними компаніями, надаючи доступ до перевірених спеціалістів, які виконують складні завдання: розмітку даних, оцінку моделей, створення контенту та експертну валідацію.',
    desc3: 'Кожен учасник платформи проходить ретельний відбір через нашого AI-рекрутера Zara, що гарантує найвищу якість роботи та професіоналізм команди.',
    englishNote: '⚠️ Важливо: Усі співбесіди та завдання на платформі виконуються англійською мовою. Вільне володіння англійською — обов\'язкова вимога для роботи.',
    quote: 'Людська експертиза залишається незамінною в епоху ШІ. micro1 перетворює людські знання та навички на фундамент, на якому будується майбутнє штучного інтелекту.',
    quoteName: 'Команда micro1',
    quoteRole: 'Платформа людського інтелекту'
  },
  forWhom: {
    title: 'Для кого ця платформа?',
    subtitle: 'micro1 відкрита для спеціалістів різних галузей, готових працювати віддалено та робити внесок у розвиток AI-технологій',
    categories: [
      {
        title: 'Анотатори та розмітчики даних',
        desc: 'Спеціалісти з розмітки зображень, текстів, аудіо та відео для навчання моделей комп\'ютерного зору, NLP та мультимодальних систем.',
        icon: 'ri-image-edit-line'
      },
      {
        title: 'Оцінювачі моделей AI',
        desc: 'Експерти, які тестують та оцінюють якість відповідей мовних моделей, перевіряють точність, безпеку та відповідність етичним стандартам.',
        icon: 'ri-star-line'
      },
      {
        title: 'Творці контенту та редактори',
        desc: 'Копірайтери, редактори та лінгвісти, які створюють якісний текстовий контент для навчання та файнтюнінгу мовних моделей різними мовами.',
        icon: 'ri-edit-line'
      },
      {
        title: 'Програмісти та розробники',
        desc: 'Спеціалісти з написання коду, перевірки рішень, створення синтетичних даних для навчання AI-моделей програмування та кодогенерації.',
        icon: 'ri-code-s-slash-line'
      },
      {
        title: 'Експерти в предметних галузях',
        desc: 'Професіонали в медицині, праві, науці, фінансах та інших сферах, які надають експертні знання для спеціалізованих AI-додатків.',
        icon: 'ri-graduation-cap-line'
      },
      {
        title: 'Спеціалісти з робототехніки',
        desc: 'Оператори, які збирають реальні дані про фізичні дії та рухи для навчання роботизованих систем та гуманоїдів нового покоління.',
        icon: 'ri-robot-2-line'
      }
    ]
  },
  opportunities: {
    badge: 'Простий процес',
    title: 'Три кроки до першого заробітку',
    steps: [
      {
        number: '01',
        title: 'Реєстрація',
        desc: 'Перейдіть за реферальним посиланням та заповніть анкету. Розкажіть про свої навички та досвід.'
      },
      {
        number: '02',
        title: 'Перевірка навичок',
        desc: 'Пройдіть тестування через AI-рекрутера Zara. Це може включати завдання, співбесіду або експертну оцінку.'
      },
      {
        number: '03',
        title: 'Вибір завдань',
        desc: 'Після схвалення отримайте доступ до платформи та обирайте завдання, що відповідають вашим навичкам та інтересам.'
      },
      {
        number: '04',
        title: 'Робота та оплата',
        desc: 'Виконуйте завдання у зручний час, отримуйте оплату за якісну роботу та розвивайте експертизу в AI-індустрії.'
      }
    ]
  },
  faq: {
    title: 'Часті питання',
    subtitle: 'Відповіді на найпоширеніші питання про роботу на платформі',
    items: [
      {
        q: 'Чи потрібно знати англійську мову для роботи?',
        a: 'Так, вільне володіння англійською мовою є обов\'язковою вимогою. Усі співбесіди з AI-рекрутером Zara, інструкції до завдань, комунікація з командою та сама робота виконуються виключно англійською. Рівень володіння буде перевірено на етапі відбору.'
      },
      {
        q: 'Скільки я можу заробити на платформі micro1?',
        a: 'Заробіток залежить від типу завдань, вашої кваліфікації та часу, який ви інвестуєте. Платформа не гарантує фіксований дохід, але багато спеціалістів отримують конкурентну винагороду за якісну роботу. Ставки варіюються залежно від складності проєкту та вашої експертизи.'
      },
      {
        q: 'Чи потрібен мені досвід роботи з ШІ для початку?',
        a: 'Ні, конкретний досвід роботи з ШІ не завжди потрібен. Багато завдань підходять для людей без технічної освіти. Основні вимоги — уважність, здатність слідувати інструкціям та бажання навчатися. Деякі спеціалізовані завдання можуть вимагати експертизи в конкретних галузях.'
      },
      {
        q: 'Як проходить процес відбору?',
        a: 'Після реєстрації ви взаємодієте з AI-рекрутером Zara, який оцінює ваші навички через тести, завдання або співбесіди (англійською мовою). Процес займає від кількох днів до кількох тижнів залежно від складності позиції. Відбір спрямований на пошук найкращих спеціалістів для кожного типу завдань.'
      },
      {
        q: 'Чи можу я працювати з будь-якої країни?',
        a: 'Так, micro1 — це глобальна платформа, відкрита для спеціалістів з різних країн. Однак деякі проєкти можуть мати регіональні обмеження або мовні вимоги (обов\'язкова англійська). Перевірте деталі під час реєстрації.'
      },
      {
        q: 'Який графік роботи на платформі?',
        a: 'Робота повністю віддалена та гнучка. Ви самі вибираєте, коли і скільки працювати, залежно від доступних завдань та вашого розкладу. Це може бути як повна зайнятість, так і підробіток у вільний час.'
      },
      {
        q: 'Як виплачується винагорода?',
        a: 'Оплата здійснюється згідно з умовами конкретного проєкту. Зазвичай використовуються міжнародні платіжні системи. Деталі щодо способів оплати, частоти та мінімальних сум уточнюються після схвалення на платформі.'
      }
    ]
  },
  finalCta: {
    title: 'Готові почати?',
    subtitle: 'Приєднуйтесь до тисяч спеціалістів по всьому світу, які допомагають створювати майбутнє AI',
    button: 'Зареєструватися зараз',
    social: 'Понад 10 000 спеціалістів вже з нами'
  },
  footer: {
    description: 'Платформа людського інтелекту для навчання AI-моделей та створення високоякісних датасетів для AGI.',
    contact: 'Контакти',
    links: 'Навігація',
    company: 'Компанія',
    careers: 'Кар\'єра',
    research: 'Дослідження'
  }
};
